
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#FE9500"}},[_c('path',{attrs:{"d":"M57.155 1.677a5.66 5.66 0 00-6.087.283 2.246 2.246 0 00-.415-.368l-.82-.472a6.287 6.287 0 00-8.583 2.305l-7.057 12.23a2.501 2.501 0 004.332 2.5L45.58 5.922a1.287 1.287 0 011.75-.472l.818.475-15.5 26.89a2.838 2.838 0 001.04 3.875l4.917 2.838a2.838 2.838 0 003.875-1.04L59.25 9.431a5.675 5.675 0 00-2.095-7.755zM38.958 42.663l-7.708-4.446a1.25 1.25 0 00-1.87.98l-.877 10.415a1.25 1.25 0 00.62 1.19 1.268 1.268 0 001.337-.06l8.578-5.972a1.25 1.25 0 00-.09-2.108h.01zM24.395 54.547a15.42 15.42 0 01-8.665-1.75 16.63 16.63 0 00-5.9-1.647 13.553 13.553 0 00-9.1 3.482 2.503 2.503 0 003.52 3.558 8.47 8.47 0 015.583-2.038c1.393.23 2.746.66 4.017 1.278a23.963 23.963 0 008.94 2.29c.912.002 1.82-.097 2.71-.295a2.499 2.499 0 00-.125-4.902 2.501 2.501 0 00-.975.024h-.005z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h60v60H0z"}})])])])
          )
        }
      }
    